module.exports = __webpack_public_path__ + "static/media/t4web.763d5466.png";